import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { GtmFlowNodeData } from "../sequenceToFlow";

export default function GtmBranchNode({ data, selected }: NodeProps) {
  const d = data as GtmFlowNodeData;
  return (
    <div
      className={`nopan min-w-[140px] rounded-lg border bg-amber-50 px-3 py-2 shadow-sm ${
        selected ? "border-amber-500 ring-2 ring-amber-200" : "border-amber-200"
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-slate-400" />
      <div className="text-[10px] font-semibold uppercase tracking-wide text-amber-700">Branch</div>
      <div className="text-sm font-medium text-gray-900">{d.label}</div>
      <Handle type="source" position={Position.Right} className="!bg-slate-400" />
    </div>
  );
}
